// extracted by mini-css-extract-plugin
export default {"modalContent":"InformTeamModal_modalContent__F2LKt","updateText":"InformTeamModal_updateText__288Ll"};